import React, { useState } from "react";
import { IconContext } from "react-icons";
import { FaLock } from "react-icons/fa";
import { PrimaryButton } from "../button";
import { LockExamModal } from "./LockExamModal";

export const LockExam = ({
  id,
  isLocked,
  lockedBusinessId,
  lockedBusinessName,
  hideFromNonMembers,
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="pin-div">
        <PrimaryButton onClick={() => setShowModal(true)} className="pbtn" size="sm">
          <IconContext.Provider value={{ color: isLocked ? "#2f67d8" : "#dfdbdb", className: "ttFav lockFav" }}>
            <div className="pinFav" title={isLocked ? `Locked to ${lockedBusinessName || "a business"}` : "Lock to a business"}>
              <FaLock />
            </div>
          </IconContext.Provider>
        </PrimaryButton>
      </div>

      {showModal && (
        <LockExamModal
          examId={id}
          currentBusinessId={lockedBusinessId}
          currentBusinessName={lockedBusinessName}
          currentHideFromNonMembers={hideFromNonMembers}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};
